import { ProductResponseDocsModel } from '@app/core/models/product/productResponseDocs.model';
import { createAction, props } from '@ngrx/store';

export const setProductsToCompare = createAction(
  '[Product Compare] List Added ',
  props<{ productsToCompare: ProductResponseDocsModel[] }>()
);
export const addProductToCompare = createAction(
  '[Product Compare] Add Product Style To Compare List',
  props<{ productToCompare: ProductResponseDocsModel }>()
);

export const removeAllProductsFromCompare = createAction('[Product Compare] Remove All Compare Products');

export const removeProductFromCompare = createAction(
  '[Product Compare] Remove Product Style Based On Style Number',
  props<{ productToCompare: ProductResponseDocsModel }>()
);

export const setProductTypeToCompare = createAction(
  '[Product Compare] Added product type to compare',
  props<{ productTypeToCompare?: string }>()
);
